import { call } from './callable';

/** Add an email to the beta waitlist. Works for signed-out visitors. */
export const joinWaitlist = call('joinWaitlist');

/**
 * Sign up. Resolves { status: 'created' } for invited emails (then sign in) or
 * { status: 'waitlisted' } otherwise.
 */
export const createAccount = call('createAccount');

/** Delete the signed-in user's profile and login. */
export const deleteAccount = call('deleteAccount');

/** Count a view of someone else's profile (deduplicated server-side). */
export const recordProfileView = (profileId) => call('recordProfileView')({ profileId });

/** Admin: grant or revoke platform admin. */
export const setAdmin = (profileId, isAdmin) => call('setAdmin')({ profileId, isAdmin });

/** Admin: start the opportunities scraper. */
export const triggerScrape = call('triggerScrape');

/** Admin: check Loops configuration. Resolves { configured, success, teamName }. */
export const loopsTestConnection = call('loopsTestConnection');

/** Admin: whether the Loops API key secret is set. Resolves false on any error. */
export const isLoopsConfigured = async () => {
  try {
    return Boolean((await call('loopsStatus')()).configured);
  } catch {
    return false;
  }
};

/** Admin: email yourself a preview of the weekly opportunity digest. */
export const sendOpportunityDigestPreview = call('sendOpportunityDigestNow');

/** Discipline and location breakdown of users who interacted with the caller's opportunities. */
export const getAudienceDemographics = (opportunityIds) => call('getAudienceDemographics')({ opportunityIds });
